import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about_company',
            name: 'about_company',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/AboutCompany.vue')
        },
        {
            path: '/about_program',
            name: 'about_program',
            component: () => import('./views/AboutProgram.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./views/Register.vue')
        },
        {
            path: '/product_comparison',
            name: 'product_comparison',
            component: () => import('./views/ProductComparison.vue')
        },
        {
            path: '/result_form',
            name: 'result_form',
            component: () => import('./views/ResultForm.vue')
        },
        {
            path: '/selection_of_the_offer',
            name: 'selection_of_the_offer',
            component: () => import('./views/SelectionOfTheOffer.vue')
        },
        {
            path: '/fan_comparison',
            name: 'fan_comparison',
            component: () => import('./views/FanComparison.vue')
        },
        {
            path: '/verify_user',
            name: 'verify_user',
            component: () => import('./views/VerifyUser.vue')
        },
        {
            path: '/offers',
            name: 'offers',
            props: true,
            component: () => import('./views/DisplayOffers.vue')
        },
        {
            path: '/detail_analysis',
            name: 'detail_analysis',
            component: () => import('./views/DetailAnalysis.vue')
        },
        {
            path: '/bafa_tables',
            name: 'bafa_tables',
            component: () => import('./views/BafaTables.vue')
        },
        {
            path: '/rodo',
            name: 'rodo',
            component: () => import('./views/RODO.vue')
        },
        {
            path: '/statute',
            name: 'statute',
            component: () => import('./views/Statute.vue')
        },
        {
            path: '/reset_password',
            name: 'reset_password',
            component: () => import('./views/ResetPassword.vue')
        },
        {
            path: '/adjust_engine',
            name: 'adjust_engine',
            component: () => import('./views/AdjustEngine.vue')
        },
    ],
    scrollBehavior(to,from,saved) {
        return {x: 0, y: 0};
    }
})
